'use strict';

import {after,each,delay,noop,size,isFunction} from 'underscore';

/**
 * Run a method on each jQuery result in a different thread.
 * @param arrayLike An array like object (can be jQuery object with results)
 * @param eachCallback (element, index, arrayLike) => void
 * @param completeCallback (arrayLike) => void
 * @returns undefined
 */
export function parallelArrayEach(arrayLike, eachCallback, completeCallback) {
  const arrayLength = size(arrayLike);
  const onComplete = isFunction(completeCallback) ? after(arrayLength, completeCallback) : noop;
  each(arrayLike, (el, i) => {
    delay(() => {
      eachCallback(el, i, arrayLike);
      onComplete(arrayLike);
    });
  });
}



// WEBPACK FOOTER //
// ./assets/utilities/uiLoopHelpers.js